import React from 'react';

const Status = () => <p>Status OK</p>;

export default Status;
